<template>
  <div class="ine-form__form-wrapper">
    <form
      @submit.prevent="validateFields"
      class="reset-password ine-form__form"
    >
      <Title
        header="Reset User's Password"
        tagline="Please enter the users email address"
        :alert="
          newPassword && newPassword.length
            ? `Password changed to: ${newPassword}`
            : ''
        "
      />
      <Errors :errors="errors.messages" />
      <div
        v-for="(field, key) in fields"
        v-show="field.type"
        :key="`field-${key}`"
        class="ine-form__form-group"
      >
        <input
          v-if="field.type"
          :type="field.type"
          :class="[
            'ine-form__form-control',
            errors.fields.includes(key) && 'ine-form__form-control--error',
          ]"
          @focus="clearErrors"
          :placeholder="field.placeholder"
          :autocomplete="field.autocomplete"
          v-model="field.value"
        />
      </div>
      <div class="ine-form__actions">
        <SubmitBtn title="Submit" iconName="lock" :isLoading="isLoading" />
      </div>
      <AdditionalLinks :linksShown="[]" />
    </form>
  </div>
</template>

<script>
import { validateForm, clearFormErrors } from '@/helpers'
import Title from '@/components/forms/elements/Title.vue'
import Errors from '@/components/forms/elements/Errors.vue'
import SubmitBtn from '@/components/forms/elements/SubmitBtn.vue'
import AdditionalLinks from '@/components/forms/elements/AdditionalLinks.vue'

export default {
  name: 'ManagePasswordForm',
  components: {
    Title,
    Errors,
    SubmitBtn,
    AdditionalLinks,
  },
  props: {
    newPassword: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      errors: clearFormErrors(),
      fields: {
        email: {
          type: 'email',
          placeholder: 'Email',
          rules: ['presence'],
          value: '',
          autocomplete: 'email',
        },
        'new password': {
          type: 'password',
          placeholder: 'New Password',
          rules: ['presence', 'password'],
          value: '',
          autocomplete: 'new-password',
        },
      },
      isLoading: false,
    }
  },
  methods: {
    clearPassword() {
      this.$store.dispatch('admin/setNewPassword', '')
    },
    async validateFields() {
      const { fields } = this
      const { isValid, errors } = validateForm(fields)
      this.errors = errors
      if (isValid) {
        const payload = {
          email: fields.email.value,
          password: fields['new password'].value,
        }
        await this.submitForm(payload)
      }
    },
    async submitForm({ email, password }) {
      this.isLoading = true
      await this.$store.dispatch('admin/adminResetPassword', {
        email,
        password,
      })
      this.isLoading = false
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
  },
  destroyed() {
    this.clearPassword()
  },
}
</script>
